import { render } from "./DirectoryAccess.vue?vue&type=template&id=090caf60"
import script from "./DirectoryAccess.vue?vue&type=script&lang=js"
export * from "./DirectoryAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__